import React, { useEffect } from 'react';
import { Box, Grid, TextField } from '@mui/material';

interface LatePaymentFieldsProps {
  values: any;
  touched: any;
  errors: any;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: React.FocusEvent<any>) => void;
}

const formatPercent = (value: string) => {
  const digits = value.replace(/\D/g, '');

  if (!digits) return '';

  let number = Number(digits) / 100;

  if (number > 100) {
    number = 100;
  }

  return `${number.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}%`;
};

const LatePaymentFields: React.FC<LatePaymentFieldsProps> = ({ values, touched, errors, handleChange, handleBlur }) => {
  const handlePercentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    const formatted = formatPercent(value);

    handleChange({
      ...e,
      target: {
        ...e.target,
        name,
        value: formatted,
      },
    });
  };

  useEffect(() => {
    const fields = ['lateFinePercent', 'lateMonthlyInterestPercent'] as const;

    fields.forEach((field) => {
      const value = values[field];
      if (!value) return;

      const formatted = formatPercent(value);

      if (formatted !== value) {
        handleChange({
          target: {
            name: field,
            value: formatted,
          },
        } as React.ChangeEvent<HTMLInputElement>);
      }
    });
  }, [values.lateFinePercent, values.lateMonthlyInterestPercent]);

  return (
    <Box pr={1} pb={1}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField
            label="Multa"
            type="text"
            fullWidth
            required
            variant="standard"
            name="lateFinePercent"
            value={values.lateFinePercent}
            onChange={handlePercentChange}
            onBlur={handleBlur}
            error={Boolean(touched.lateFinePercent && errors.lateFinePercent)}
            helperText={touched.lateFinePercent && errors.lateFinePercent}
            InputLabelProps={{
              shrink: true,
              sx: { fontSize: '16px', fontWeight: 500 },
            }}
            InputProps={{ sx: { fontSize: '14px' } }}
            placeholder="Exemplo: 2,00%"
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            label="Juros de mora ao mês"
            type="text"
            fullWidth
            required
            variant="standard"
            name="lateMonthlyInterestPercent"
            value={values.lateMonthlyInterestPercent}
            onChange={handlePercentChange}
            onBlur={handleBlur}
            error={Boolean(touched.lateMonthlyInterestPercent && errors.lateMonthlyInterestPercent)}
            helperText={touched.lateMonthlyInterestPercent && errors.lateMonthlyInterestPercent}
            InputLabelProps={{
              shrink: true,
              sx: { fontSize: '16px', fontWeight: 500 },
            }}
            InputProps={{ sx: { fontSize: '14px' } }}
            placeholder="Exemplo 1,00%"
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            label="Máximo de dias permitido"
            type="number"
            fullWidth
            required
            variant="standard"
            name="lateDays"
            value={values.lateDays}
            onChange={handleChange}
            onBlur={handleBlur}
            error={Boolean(touched.lateDays && errors.lateDays)}
            helperText={touched.lateDays && errors.lateDays}
            InputLabelProps={{
              shrink: true,
              sx: { fontSize: '16px', fontWeight: 500 },
            }}
            InputProps={{ sx: { fontSize: '14px' } }}
            placeholder="Prazo máximo após o vencimento"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default LatePaymentFields;
